/**
 * Workers Module Routes
 *
 * Route definitions for the job monitoring dashboard.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/workers',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.workers',
        },
        children: [
            {
                path: '',
                name: 'workers-job-list',
                component: () => import('./views/JobList.vue'),
                meta: {
                    title: 'Workers',
                },
            },
            {
                path: 'jobs/:id',
                name: 'workers-job-detail',
                component: () => import('./views/JobDetail.vue'),
                meta: {
                    title: 'Job Detail',
                },
            },
        ],
    },
]

export default routes
